import React from 'react';
import useNivoLine from '../../charts/nivo/useNivoLine';
import NivoLineController from '../../charts/nivo/NivoLineController';
import {COOL_COLOR_PALETTE} from "../../utils/colorUtils";


const EtfCumulativeLineChart = ({ etfs }) => {
    const maxHoldingsLength = Math.max(...etfs.map(etf => etf.holdings.length));

    // Prepare data
    let index = 0;
    const data = etfs.map(etf => {
        let cumulativeWeight = 0;
        const color = COOL_COLOR_PALETTE[index];
        index++;
        return {
            id: etf.name,
            color,
            data: etf.holdings.map((holding, index) => {
                cumulativeWeight += holding.wgt;
                return {
                    x: index + 1,
                    y: cumulativeWeight * 100,
                };
            })
        };
    });

    const {
        chartData, config, setConfig
    } = useNivoLine({
        data,
        xScale: { type: 'linear', min: 1, max: maxHoldingsLength },
        yScale: { type: 'linear', min: 0, max: 100 },
        isArea: false,
        pointSize: 1,
        enablePoints: false
    });

    return (
        <NivoLineController
            data={chartData}
            xScale={config?.xScale}
            yScale={config?.yScale}
            config={config}
            setConfig={setConfig}
            height={'80vh'}
        />
    );
};

export default EtfCumulativeLineChart;
